import {
  CLEAR_EXTERNAL_ACCOUNT,
  CREATE_EXTERNAL_ACCOUNT_FAILURE,
  CREATE_EXTERNAL_ACCOUNT_REQUEST,
  CREATE_EXTERNAL_ACCOUNT_SUCCESS,
  DELETE_EXTERNAL_ACCOUNT_FAILURE,
  DELETE_EXTERNAL_ACCOUNT_REQUEST,
  DELETE_EXTERNAL_ACCOUNT_SUCCESS,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_FAILURE,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_REQUEST,
  GET_EXTERNAL_ACCOUNTS_BY_TYPE_SUCCESS,
  GET_EXTERNAL_ACCOUNT_BY_ID_FAILURE,
  GET_EXTERNAL_ACCOUNT_BY_ID_REQUEST,
  GET_EXTERNAL_ACCOUNT_BY_ID_SUCCESS,
  SET_MODAL_TYPE,
  UPDATE_EXTERNAL_ACCOUNT_FAILURE,
  UPDATE_EXTERNAL_ACCOUNT_REQUEST,
  UPDATE_EXTERNAL_ACCOUNT_SUCCESS,
} from 'actionConstants';
import apiClient from 'apiClient';
import { CONFIRM } from 'components/Modal/modalTypes';

import i18n from 'shared/lib/i18n';

export const getExternalLinksList = (dispatch, queryParams) =>
  dispatch({
    type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_REQUEST,
    payload: apiClient.customIntegrations
      .getExternalLinksList(queryParams)
      .then(
        (res) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_SUCCESS,
            accountType: 'external_links',
            res,
          }),
        (err) =>
          dispatch({
            type: GET_EXTERNAL_ACCOUNTS_BY_TYPE_FAILURE,
            err,
          }),
      ),
  });

export const getExternalLink = (dispatch, accountId) =>
  dispatch({
    type: GET_EXTERNAL_ACCOUNT_BY_ID_REQUEST,
    payload: apiClient.customIntegrations.getExternalLink(accountId).then(
      (res) =>
        dispatch({
          type: GET_EXTERNAL_ACCOUNT_BY_ID_SUCCESS,
          accountId,
          res,
        }),
      (err) =>
        dispatch({
          type: GET_EXTERNAL_ACCOUNT_BY_ID_FAILURE,
          err,
        }),
    ),
  });

export const createExternalLink = (dispatch, data) =>
  dispatch({
    type: CREATE_EXTERNAL_ACCOUNT_REQUEST,
    isForm: true,
    payload: apiClient.customIntegrations.createExternalLink(data).then(
      (res) => {
        dispatch({
          type: CREATE_EXTERNAL_ACCOUNT_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: CREATE_EXTERNAL_ACCOUNT_FAILURE,
          err,
        }),
    ),
  });

export const updateExternalLink = (dispatch, linkId, data) =>
  dispatch({
    type: UPDATE_EXTERNAL_ACCOUNT_REQUEST,
    isForm: true,
    payload: apiClient.customIntegrations.updateExternalLink(linkId, data).then(
      (res) => {
        dispatch({
          type: UPDATE_EXTERNAL_ACCOUNT_SUCCESS,
          res,
        });
        return res;
      },
      (err) =>
        dispatch({
          type: UPDATE_EXTERNAL_ACCOUNT_FAILURE,
          err,
        }),
    ),
  });

export const deleteExternalLink = (dispatch, linkId) =>
  dispatch({
    type: DELETE_EXTERNAL_ACCOUNT_REQUEST,
    payload: apiClient.customIntegrations.deleteExternalLink(linkId).then(
      (res) =>
        dispatch({
          type: DELETE_EXTERNAL_ACCOUNT_SUCCESS,
          res,
        }),
      (err) =>
        dispatch({
          type: DELETE_EXTERNAL_ACCOUNT_FAILURE,
          err,
        }),
    ),
  });

export const confirmToDeleteExternalLink = (
  dispatch,
  accountId,
  callback,
  listParams,
) => {
  const modalProps = {
    bodyText: i18n.t('modal.title.areYouSure'),
    onConfirm: async () => {
      await deleteExternalLink(dispatch, accountId);
      callback(dispatch, listParams);
    },
  };
  dispatch({
    type: SET_MODAL_TYPE,
    modalType: CONFIRM,
    modalProps,
  });
};

export const clearExternalLink = (dispatch) =>
  dispatch({
    type: CLEAR_EXTERNAL_ACCOUNT,
  });
